import { render, staticRenderFns } from "./OperaCategoryDcaProblemWindow.vue?vue&type=template&id=11f3898c&"
import script from "./OperaCategoryDcaProblemWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCategoryDcaProblemWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports